import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import RequiredIndicator from 'pages/ApplicationRequest/components/containers/RequiredIndicator';
import CustomFormControl from './CustomFormControl';
import CustomHelperText from './CustomHelperText';
import { BEM_NAME_ELEMENTS } from 'pages/NewNonEmployee/_const';

/**
 * customized field prompting user for checking a box
 * @param {string|ReactElement} label label to display
 * @param {boolean} required if required, display an indicator
 * @param {string|ReactElement} helperText default on-screen assistance
 * @param {any} props properties to be passed to the checkbox
 * @returns {ReactElement} checkbox prompting for user input
 */
const CustomCheckbox = ({ label, required, helperText, ...props }) => {
	const [field, meta] = useField(props);

	return (
		<CustomFormControl error={meta.touched && !!meta.error}>
			<FormGroup>
				<FormControlLabel
					control={
						<Checkbox
							{...props}
							{...field}
							checked={field.value}
							id={`${BEM_NAME_ELEMENTS.VIEW_FORM}__${BEM_NAME_ELEMENTS.FIELD_CHECKBOX}--${props.name}`}
						/>
					}
					label={
						<>
							{required && <RequiredIndicator />}
							{label}
						</>
					}
				/>
			</FormGroup>
			<CustomHelperText
				error={meta.error}
				touched={meta.touched}
				helperText={helperText}
			/>
		</CustomFormControl>
	);
};

CustomCheckbox.propTypes = {
	label: PropTypes.string.isRequired,
	required: PropTypes.bool,
	helperText: PropTypes.string,
	name: PropTypes.string.isRequired,
};

export default CustomCheckbox;
